import React from 'react';
import { Link } from 'react-router-dom';
import { Smartphone, Monitor, ShieldCheck, TrendingUp } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { Card } from '../components/ui/card';
import { Button } from '../components/ui/button';

export const DashboardPage = () => {
  const { t } = useLanguage();

  const quickActions = [
    {
      title: t('dashboard.menu.new_soft_token'),
      description: t('soft_token.description'),
      icon: Smartphone,
      link: '/dashboard/new-soft-token',
      color: 'bg-blue-50 text-blue-600 dark:bg-blue-950 dark:text-blue-400',
      testId: 'quick-action-soft-token'
    },
    {
      title: t('dashboard.menu.new_desktop_token'),
      description: t('desktop_token.description'),
      icon: Monitor,
      link: '/dashboard/new-desktop-token',
      color: 'bg-purple-50 text-purple-600 dark:bg-purple-950 dark:text-purple-400',
      testId: 'quick-action-desktop-token'
    },
    {
      title: t('dashboard.menu.manage_tokens'),
      description: t('manage_tokens.description'),
      icon: ShieldCheck,
      link: '/dashboard/manage-tokens',
      color: 'bg-emerald-50 text-emerald-600 dark:bg-emerald-950 dark:text-emerald-400',
      testId: 'quick-action-manage-tokens'
    },
  ];

  return (
    <div className="space-y-8" data-testid="dashboard-page">
      {/* Welcome Section */}
      <div>
        <h1 className="font-outfit font-bold text-3xl sm:text-4xl text-foreground mb-2 tracking-tight" data-testid="dashboard-title">
          {t('dashboard.welcome')}
        </h1>
        <p className="text-muted-foreground font-ibm text-base" data-testid="dashboard-subtitle">
          Manage your authentication tokens securely
        </p>
      </div>

      {/* Quick Actions Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="quick-actions-grid">
        {quickActions.map((action) => {
          const Icon = action.icon;
          return (
            <Link key={action.link} to={action.link} data-testid={action.testId}>
              <Card className="p-6 hover:shadow-md transition-shadow duration-200 h-full border border-border">
                <div className="flex items-start gap-4">
                  <div className={`p-3 rounded-lg ${action.color}`}>
                    <Icon className="h-6 w-6" />
                  </div>
                  <div className="flex-1 space-y-2">
                    <h3 className="font-outfit font-semibold text-lg text-foreground">
                      {action.title}
                    </h3>
                    <p className="text-sm text-muted-foreground font-ibm leading-relaxed">
                      {action.description}
                    </p>
                  </div>
                </div>
              </Card>
            </Link>
          );
        })}
      </div>

      {/* Stats section removed - moved to Manage Tokens page */}
    </div>
  );
};
